import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
interface StepNavProps {
  backLabel?: string;
  onBack?: () => void;
  nextLabel?: string;
  onNext?: () => void;
  onRestart?: () => void;
}
export function StepNav({
  backLabel,
  onBack,
  nextLabel,
  onNext,
  onRestart
}: StepNavProps) {
  return <div className="w-full flex-shrink-0 pt-3" data-id="element-119" data-mp="30ihx6vldpgku">
      {nextLabel && onNext && <button onClick={onNext} className="w-full rounded-2xl bg-solventum-primary px-6 py-4 font-headline text-lg font-extrabold text-solventum-bg shadow-[0_0_24px_rgba(5,221,77,0.25)] transition-transform duration-150 active:scale-[0.98]" data-id="element-120" data-mp="3o958lqui6oc5">
          {nextLabel} →
        </button>}

      <div className="mt-2 flex items-center justify-between" data-id="element-121" data-mp="3j8zjahbphdx8">
        {backLabel && onBack ? <button onClick={onBack} className="flex items-center gap-1 py-1.5 font-body text-sm text-solventum-primary transition-colors duration-150 hover:text-white" data-id="element-122" data-mp="22v9dn64xuhlh">
            <ChevronLeftIcon className="h-4 w-4" data-id="element-123" data-mp="t040jymcy482" />
            {backLabel}
          </button> : <span data-id="element-124" data-mp="oysj4gdn0pay" />}

        {onRestart && <button onClick={onRestart} className="py-1.5 font-body text-[11px] uppercase tracking-[0.2em] text-white/30 transition-colors duration-150 hover:text-white/70" data-id="element-125" data-mp="12x8pu7bi2ft3">
            Replay
          </button>}
      </div>
    </div>;
}